/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './ledger';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "service": {
            "nested": {
              "GetDepositScheduleRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetDepositScheduleResponse": {
                "fields": {
                  "currentWeeklyDepositSchedule": {
                    "type": "squareup.ledger.service.WeeklyDepositSchedule",
                    "id": 1,
                    "rule": "optional"
                  },
                  "nextWeeklyDepositSchedule": {
                    "type": "squareup.ledger.service.WeeklyDepositSchedule",
                    "id": 2,
                    "rule": "optional"
                  },
                  "potentialDepositSchedule": {
                    "type": "squareup.ledger.PotentialDepositSchedule",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "hasUserSetCustomSchedule": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "defaultCutoffTime": {
                    "type": "squareup.common.time.LocalTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "settlementFrequency": {
                    "type": "squareup.ledger.SettlementFrequency",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "DayOfWeekDepositSettings": {
                "fields": {
                  "dayOfWeek": {
                    "type": "squareup.common.time.DayOfWeek",
                    "id": 1,
                    "rule": "optional"
                  },
                  "depositInterval": {
                    "type": "squareup.ledger.DepositInterval",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "WeeklyDepositSchedule": {
                "fields": {
                  "effectiveAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "dayOfWeekDepositSettings": {
                    "type": "squareup.ledger.service.DayOfWeekDepositSettings",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "settleIfOptional": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "pausedSettlement": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "RequestSource": {
                "values": {
                  "UNKNOWN_DO_NOT_USE": 0,
                  "REGISTER": 1,
                  "DASHBOARD": 2,
                  "INTERNAL": 3
                }
              },
              "SetDepositScheduleRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "dayOfWeekDepositSettings": {
                    "type": "squareup.ledger.service.DayOfWeekDepositSettings",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "requestSource": {
                    "type": "squareup.ledger.service.RequestSource",
                    "id": 4,
                    "rule": "optional"
                  },
                  "settleIfOptional": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "enableDailySameDaySettlement": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "pauseSettlement": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "SetDepositScheduleResponse": {
                "fields": {
                  "currentWeeklyDepositSchedule": {
                    "type": "squareup.ledger.service.WeeklyDepositSchedule",
                    "id": 1,
                    "rule": "optional"
                  },
                  "nextWeeklyDepositSchedule": {
                    "type": "squareup.ledger.service.WeeklyDepositSchedule",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.GetDepositScheduleRequest && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.GetDepositScheduleResponse && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.DayOfWeekDepositSettings && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.WeeklyDepositSchedule && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.RequestSource && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.SetDepositScheduleRequest && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.SetDepositScheduleResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetDepositScheduleRequest @ squareup/ledger/deposit_settings.proto at 16:1
 */
export const GetDepositScheduleRequest = $root.lookupType('squareup.ledger.service.GetDepositScheduleRequest');
fixType(GetDepositScheduleRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetDepositScheduleRequest);
/**
 * SOURCE GetDepositScheduleResponse @ squareup/ledger/deposit_settings.proto at 28:1
 */
export const GetDepositScheduleResponse = $root.lookupType('squareup.ledger.service.GetDepositScheduleResponse');
fixType(GetDepositScheduleResponse, {
  currentWeeklyDepositSchedule: {
    required: true
  },
  potentialDepositSchedule: {
    required: true
  },
  hasUserSetCustomSchedule: {
    required: true
  }
});
Builder.createAndAttachToType(GetDepositScheduleResponse);
/**
 * A merchant's deposit settings for a specified day of the week.
 *
 * SOURCE DayOfWeekDepositSettings @ squareup/ledger/deposit_settings.proto at 52:1
 */
export const DayOfWeekDepositSettings = $root.lookupType('squareup.ledger.service.DayOfWeekDepositSettings');
fixType(DayOfWeekDepositSettings, {
  dayOfWeek: {
    required: true
  },
  depositInterval: {
    required: true
  }
});
Builder.createAndAttachToType(DayOfWeekDepositSettings);
/**
 * SOURCE WeeklyDepositSchedule @ squareup/ledger/deposit_settings.proto at 64:1
 */
export const WeeklyDepositSchedule = $root.lookupType('squareup.ledger.service.WeeklyDepositSchedule');
fixType(WeeklyDepositSchedule, {
  timezone: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WeeklyDepositSchedule);
/**
 * The product/service used to initiate a request.
 *
 * SOURCE RequestSource @ squareup/ledger/deposit_settings.proto at 90:1
 */
export const RequestSource = $root.lookupEnum('squareup.ledger.service.RequestSource').values;
/**
 * SOURCE SetDepositScheduleRequest @ squareup/ledger/deposit_settings.proto at 101:1
 */
export const SetDepositScheduleRequest = $root.lookupType('squareup.ledger.service.SetDepositScheduleRequest');
fixType(SetDepositScheduleRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetDepositScheduleRequest);
/**
 * SOURCE SetDepositScheduleResponse @ squareup/ledger/deposit_settings.proto at 138:1
 */
export const SetDepositScheduleResponse = $root.lookupType('squareup.ledger.service.SetDepositScheduleResponse');
fixType(SetDepositScheduleResponse, {
  currentWeeklyDepositSchedule: {
    required: true
  }
});
Builder.createAndAttachToType(SetDepositScheduleResponse);